<template>
    <div :class="{'form-group': label}">
        <label v-if="label">{{ label }}</label>

        <div class="form-row">
            <div class="col-6 col-xs-3 col-sm-3 col-md-3">
                <select class="form-control" name="country_code" v-model="register_form.country_code">
                    <option v-for="code in country_codes" :key="code.callCode + code.code" :value="code.code">
                        {{code.code}}
                    </option>
                </select>
            </div>

            <div class="col-6 col-sm-3 col-md-3" v-show="showAreaCode">
                <input class="form-control" type="number" name="area_code"
                    :class="{'is-invalid': register_form.errors.has('phone')}"
                    @change="getAvailableNumber"
                    v-model="register_form.area_code"
                />
            </div>

            <div class="col mt-4 mt-sm-0 mt-md-0">
                <input class="form-control" name="phone" v-model="register_form.phone"
                    disabled v-if="!searching"
                    :class="{'is-invalid': register_form.errors.has('phone')}"
                />
                <input class="form-control" name="phone" disabled placeholder="Searching..." v-if="searching">
            </div>

            <div class="col-12">
                <span class="invalid-feedback"
                    :class="{ phone__not__found: register_form.errors.has('phone') && codeNotFound && showAreaCode }">
                    The area code field is required to generate a phone number.
                </span>

                <span class="invalid-feedback" :class="{ phone__not__found: phone_not_found }">
                    We don't have a phone number for this area, please choose another area code.
                </span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['register_form', 'label'],

        data : () => ({
            country_codes  : [],
            phone_not_found: false,
            searching      : false,
        }),

        created() {
            this.getCountryCodes();
        },

        watch: {
            'register_form.country_code': function (newVal) {
                this.register_form.area_code = '';
                this.register_form.phone     = '';
                this.phone_not_found         = false;

                if (newVal === 'AU') {
                    this.getAvailableNumber();
                    return;
                }
            },
        },

        computed: {
            showAreaCode() {
                return this.register_form.country_code !== 'AU';
            },

            codeNotFound() {
                return !this.register_form.area_code;
            }
        },

        methods: {
            getAvailableNumber() {
                this.phone_not_found = false;

                if (this.showAreaCode && !this.register_form.area_code) {
                    this.register_form.phone = '';
                    return;
                }

                this.searching = true;
                axios.get(this.$laroute.route('api.register.available-twilio-numbers') + '?code=' +
                    this.register_form.country_code + '&area_code=' +
                    this.register_form.area_code).then((response) => {
                        if (response.data.phoneNumber) {
                            this.searching           = false;
                            this.register_form.phone = response.data.phoneNumber;
                        }
                    }).catch((err) => {
                        if (err.response.status === 404) {
                            this.searching           = false;
                            this.register_form.phone = '';
                            this.phone_not_found     = true;
                        }
                    });
            },

            getCountryCodes() {
                axios.get(this.$laroute.route('api.register.country-codes')).then((response) => {
                    this.country_codes = response.data;
                }).catch((err) => {
                    console.log(err)
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .phone__not__found {
        display: block;
    }
</style>
